import React from 'react';

import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';
import Button from 'shared/button';

interface Props {
  show: boolean;
  onDelete: () => void;
  onHide: () => void;
}

export default function AttachmentDeletionConfirmation({ show, onDelete, onHide }: Props) {
  const handleOpenChange = (open: boolean) => {
    if (!open) onHide();
  };

  return (
    <Dialog open={show} onOpenChange={handleOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Delete Attachment</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>Are you sure you want to delete this attachment?</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button.Danger onClick={onDelete}>Delete</Button.Danger>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
